import React, { useState, useEffect } from 'react';
import { useAppData } from './context/DataContext';
import { useNavigate } from 'react-router-dom';
import { Card, Button, Typography, Row, Col, Empty, Spin } from 'antd';
import Navbar from './Navbar';
const { Title, Text } = Typography;

function MyOrganizations() {
  const { userInfo, selectedOrganization, managedOrganizations, loggedInEmail } = useAppData();
  const [loading, setLoading] = useState(true);
  const [authChecked, setAuthChecked] = useState(false);
  const navigate = useNavigate();

    console.log(userInfo)
    console.log(selectedOrganization)
    console.log(loggedInEmail)

  useEffect(() => {
    // Give the app a moment to load user data before redirecting
    const timer = setTimeout(() => {
      setAuthChecked(true);
    }, 1000);
    
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    // Only redirect if we've checked auth status and there's no logged-in user
    if (authChecked && !loggedInEmail?.data) {
      navigate('/');
      return;
    }
    
    // Set loading to false once data is available
    if (managedOrganizations) {
      setLoading(false);
    }
  }, [userInfo, managedOrganizations, navigate, authChecked, loggedInEmail]);

  // Display a different message if the user has no organizations
  const renderOrganizations = () => {
    if (loading) {
      return (
        <div className="loading-container">
          <Spin size="large" />
          <p>Loading your organizations...</p>
        </div>
      );
    }

    if (!managedOrganizations || managedOrganizations.length === 0) {
      return (
        <Empty
          description="You don't have any organizations yet"
          image={Empty.PRESENTED_IMAGE_SIMPLE}
        >
          <Button type="primary" onClick={() => navigate('/newCreateEvent')}>
            Create an event
          </Button>
        </Empty>
      );
    }

    return (
      <Row gutter={[16, 16]}>
        {managedOrganizations.map((org) => (
          <Col xs={24} sm={12} md={8} key={org._id}>
            <Card 
              className={`org-card ${org._id === selectedOrganization ? 'selected-org' : ''}`}
              title={org.name}
              extra={org._id === selectedOrganization && <span className="default-badge">Default</span>}
              actions={[
                <Button type="link" onClick={() => navigate('/organization')}>Manage</Button>,
                <Button type="link" onClick={() => navigate('/newCreateEvent')}>Create Event</Button>
              ]}
            >
              <div className="card-content">
                {org.profilePicture ? (
                  <img 
                    src={org.profilePicture} 
                    alt={org.name} 
                    className="org-profile-pic"
                  />
                ) : (
                  <div className="org-profile-placeholder">
                    {org.name.charAt(0).toUpperCase()}
                  </div>
                )}
                <div className="org-details">
                  <Text>{org.description || 'No description'}</Text>
                  <Text>Events: {org.events ? org.events.length : 0}</Text>
                  <Text>Created: {new Date(org.createdAt).toLocaleDateString()}</Text>
                </div>
              </div>
            </Card>
          </Col>
        ))}
      </Row>
    );
  };

  return (
    <div className="my-organizations-page">
      <Navbar />
      <div className="organizations-container">
        <div className="header">
          <Title level={2}>My Organizations</Title>
          <Text type="secondary">
            Manage your organizations and create events
          </Text>
        </div>
        
        {renderOrganizations()}
      </div>
    </div>
  );
}

export default MyOrganizations; 